export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ROLE_OPTIONS = ["admin", "account_manager", "trader", "viewer"] as const;
